module.exports = __webpack_public_path__ + "img/progress-wrench.1fc2770.png";